import XRegExp from 'xregexp';

/**
 * Convert a string into a URL-friendly link representation
 *
 * @returns {string}
 */
String.prototype.linkify = function() {
    return this.trim()
        .replace(XRegExp('[^\\p{L}0-9 ]*', 'g'), '')
        .replace(/ /g, '-')
        .replace(/--+/g, '-');
};
